import LyFileUpload from './src/index.vue'

LyFileUpload.install = function (Vue) {
    Vue.component(LyFileUpload.name, LyFileUpload)
}

export default LyFileUpload



//////////////////
// WEBPACK FOOTER
// ../projectCore/src/components/file-upload/index.js
// module id = null
// module chunks = 